/**
 * Resources/Index Controller
 *
 * Displays a list of resources within a provided category
 */

// the constructor for this object
function ResourcesIndexController() { }

// the object
ResourcesIndexController.prototype = {
    constructor: ResourcesIndexController,

    // the category id to search for resources
    categoryId: false,

    // this contains the pagination object
    pagination: false,

    // the url last used to get resource data
    lastUsedUrl: '',

    // initialize the controller
    init: function()
    {
        // redirect the user if they're not logged in
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        // set up the pagination
        this._setupPagination();

        PortalHelper.debugMessage('Resources Index Initialized');
    },

    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();

        // set the headline on the template
        this._setHeadline();

        // get and populate the orders
        this._getResources();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Resources Index Controller Ran');
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();

        // set the category id
        if (segments.length == 1) {
            this.categoryId = segments[0];
        } else {
            PortalHelper.sendToDashboard();
        }
    },

    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#resources-pagination';
        pagination.contentSelector = '#resources-list';
        pagination.searchSelector = '#portal-search';
        pagination.eventCallback = PortalMain.ResourcesIndexController._getResources;
        PortalMain.ResourcesIndexController.pagination = pagination;
    },

    // change the headline
    _setHeadline: function()
    {
        var category = PortalMain.PortalResources.getResourceCategory(this.categoryId);

        $('#resources-title').html(category.title);
    },

    // register the javascript events
    _registerEvents:  function()
    {
    },

    // get the resources from the website api
    _getResources: function()
    {
        // build the url
        var resourcesUrl = PortalConfig.resourcesUrl;
        resourcesUrl += '?portal-resource-categories=' + PortalMain.ResourcesIndexController.categoryId;
        resourcesUrl += '&page=' + PortalMain.ResourcesIndexController.pagination.currentPage;

        var searchValue = $('#portal-search input').val();
        if (searchValue) {
            resourcesUrl += '&search=' + searchValue;
        }

        // make sure the new request isn't the same as the previous one
        if (resourcesUrl == PortalMain.ResourcesIndexController.lastUsedUrl) {
            PortalMain.ResourcesIndexController.pagination.showPagination();
            return;
        }

        // save the last used url so as not to repeat requests
        PortalMain.ResourcesIndexController.lastUsedUrl = resourcesUrl;

        // make the request
        $.ajax({
            url: resourcesUrl,
            method: 'GET',
            success: function(data){

                //handle pagination
                var paginationData = {
                    last_page: data.meta.pagination.total_pages
                };
                PortalMain.ResourcesIndexController.pagination.updatePagination(paginationData);
                PortalMain.ResourcesIndexController.pagination.showPagination();

                // get the last pagination event
                var lastEvent = PortalMain.ResourcesIndexController.pagination.lastEvent;

                // fill the invoice chart data
                PortalMain.ResourcesIndexController._populateResourcesList(data, lastEvent);

            }
        });
    },

    // populate the resources list
    _populateResourcesList: function(resourcesData, lastPaginationEvent)
    {
        var resources = resourcesData.data;

        // clear the old resources
        if (lastPaginationEvent != 'more') {
            $('#resources-list article:not(.clone-source)').remove();
        }

        // add the new resources to the DOM
        for (var i in resources) {
            var resource = resources[i];
            var newEntry = $('#resources-list .clone-source').clone();
            newEntry.removeClass('clone-source');

            // set the url
            var resourceUrl = PortalConfig.portalUrl + '/resources/view/' + resource.id;
            if (resource.alternativeLinkUrl) {
                // format the alternative link if needed
                var altLink = resource.alternativeLinkUrl;
                if (altLink.substr(0,4) !== 'http' && altLink.substr(0,1) != '/') {
                    altLink = '/' + altLink;
                }
                resourceUrl = altLink;
            }
            $('a', newEntry).attr('href', resourceUrl);

            // set the link title if applicable
            if (resource.alternativeLinkText) {
                $('a.resources__link', newEntry).html(resource.alternativeLinkText);
            }

            // set the image
            var imageSrc = resource.image[0].thumbnail;
            $('.resources__image', newEntry).attr('src', imageSrc);

            // set the title
            $('.resources__title a', newEntry).html(resource.title);

            // set the excerpt
            if(resource.excerpt != '') {
                $('.resources__excerpt', newEntry).html(resource.excerpt);
            } else if (resource.body != '') {
                // there is not a pre-defined excerpt, so we need to create one
                var resourceBody = $(resource.body);
                // text of the first element in the body of the resource, ideally a paragraph
                var resourceBodyText = resourceBody[0].innerText;
                $('.resources__excerpt', newEntry).text(resourceBodyText);
            } else {
                $('.resources__excerpt', newEntry).text(''); // no excerpt
            }

            // set the date
            var dateArr = resource.postDate.date.split(/[^0-9]/);
            var date = new Date (dateArr[0], dateArr[1]-1, dateArr[2], dateArr[3], dateArr[4], dateArr[5]);

            $('.resources__meta .date', newEntry).text(
                PortalMain.ResourcesIndexController._formatPostDate(date)
            );

            $('#resources-list').append(newEntry);

        }

    },

    /*
        Because JS doesn't have a sane way to format dates using the built-in
        Date object, we get this
    */
    _formatPostDate: function(date)
    {
        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        var month = date.getMonth();
        var day = date.getDate();
        var year = date.getFullYear();

        return monthNames[month] + ' ' + day + ', ' + year;

    },

}